import React from 'react';
import { EditCertificationItemModal } from './edit-certification-item-modal.component';
import { useEditCertificationItemModalService } from './edit-certification-item-modal.service';
import type { EditCertificationItemModalContainerProps } from './edit-certification-item-modal.types';

export const EditCertificationItemModalContainer = (
  props: EditCertificationItemModalContainerProps,
) => {
  const serviceProps = useEditCertificationItemModalService(props);
  return <EditCertificationItemModal {...serviceProps} />;
};
